// ReportDataForDevicesRequest.
//
// Class representing a report data request given selected devices.
export class ReportDataForDevicesRequest {
  public descending: boolean;
  public endDate: Date | undefined;
  public includeVerifiedPassagesOnly: boolean;
  public page: number;
  public rowsPerPage: number;
  public sortBy: string;
  public startDate: Date | undefined;
  public uidList: number[] | undefined;

  public constructor() {
    this.page = -1;
    this.rowsPerPage = -1;
    this.sortBy = '';
    this.descending = false;
    this.includeVerifiedPassagesOnly = false;
  }
}
